function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9707 9.16347L16.0438 9.23633L16.1471 9.23633L18 9.23633L18.6043 9.23633L18.1766 8.8094L10.1766 0.822769L10 0.646436L9.82337 0.822769L1.82337 8.8094L1.39573 9.23632L2 9.23632L3.5 9.23632L3.59919 9.23632L3.6714 9.16832L9.99515 3.21257L15.9707 9.16347Z",
  fill: "#4F4F4F",
  stroke: "#4F4F4F",
  strokeWidth: 0.5
});

var SvgArrowUpBoldIcon = function SvgArrowUpBoldIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUpBoldIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-up-bold-icon.38928c6b.svg";
export { ForwardRef as ReactComponent };